import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyDifferent } from './components/WhyDifferent';
import { ClientProfile } from './components/ClientProfile';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { CaseStudies } from './components/CaseStudies';
export function App() {
  return <div className="font-sans bg-white text-[#1A1A1A] min-h-screen" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <WhyDifferent data-id="element-5" />
        <CaseStudies data-id="element-6" />
        <ClientProfile data-id="element-7" />
        <CTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}